import { useEffect } from "react"
import { notification } from "components/common"
import { fieldMapper } from "../../../../../utils"
import { useLatest } from "./useLatest"

function proofKey(proof) {
  if (!proof) return ""
  return proof.url || proof.fileList?.[0]?.uid || proof.fileList?.[0]?.name || proof.name || ""
}

function ocrKey(proof, imageData) {
  if (!proof || !imageData) return ""
  const part =
    imageData.id ??
    imageData.chequeNumber ??
    imageData.referenceNumber ??
    imageData.transactionNumber ??
    imageData.payorderNumber ??
    imageData.serialNumber ??
    ""
  const bankKey = imageData.Bank?.key ?? ""
  return `${proofKey(proof)}|${part}|${bankKey}`
}

export function usePaymentRowEffects({
  fullPath,
  form,
  paymentProof,
  ocrData,
  modeOfPayment,
  paymentModesMap,
  validateReference,
  getBankName,
  getPaymentMode,
}) {
  const getPaymentModeNow = useLatest(getPaymentMode)
  const apis = useLatest({ validateReference, getBankName })

  const attachmentType = paymentProof?.attachmentType

  useEffect(() => {
    const paymentModeMetaId = attachmentType == null ? null : (paymentModesMap?.[attachmentType]?.meta?.id ?? null)

    if (attachmentType != null && paymentModeMetaId != null) {
      getPaymentModeNow.current(paymentModeMetaId, true)
    }

    if (!modeOfPayment) return

    const imageData = ocrData?.imageData
    const meta = paymentModesMap?.[modeOfPayment]?.meta
    const rowForm = {
      setFieldsValue: values => {
        Object.keys(values || {}).forEach(k => form.setFieldValue([...fullPath, k], values[k]))
      },
    }

    const { getBankName: fetchBanks, validateReference: validateChequeRef } = apis.current

    if (!imageData || !ocrKey(paymentProof, imageData)) return

    if (modeOfPayment === "cheque") {
      fetchBanks({}, true)
      fieldMapper(imageData, meta?.cheque, rowForm)
      if (imageData.chequeNumber) {
        validateChequeRef({
          referenceNumber: imageData.chequeNumber,
          bankKey: imageData?.Bank?.key,
          paymentModeKey: modeOfPayment,
        })
          .unwrap()
          .then(() => form.validateFields([[...fullPath, "referenceNumber"]]))
          .catch(e => notification.error({ message: e.message }))
      }
    } else if (modeOfPayment === "online_payment") {
      fetchBanks({}, true)
      fieldMapper(imageData, meta?.onlinePayment, rowForm)
      form.setFieldValue([...fullPath, "paymentType"], imageData?.onlinePaymentType)
    } else if (modeOfPayment === "card_payment") {
      fieldMapper(imageData, meta?.cardPayment, rowForm)
    } else if (modeOfPayment === "cash") {
      fetchBanks({}, true)
      fieldMapper(imageData, meta?.depositSlip, rowForm)
    } else if (modeOfPayment === "bank_order") {
      fetchBanks({}, true)
      fieldMapper(imageData, meta?.bankOrder, rowForm)
    }
  }, [
    apis,
    attachmentType,
    form,
    fullPath,
    getPaymentModeNow,
    modeOfPayment,
    ocrData?.imageData,
    paymentModesMap,
    paymentProof?.fileList,
    paymentProof?.name,
    paymentProof?.url,
  ])
}
